
import React from "react";
import "./UsersTable.css";
import { useGlobalContext } from "../../context";
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DeleteIcon from '@mui/icons-material/Delete';
import CachedIcon from '@mui/icons-material/Cached';
import { updateUser } from "../../api";
import { useNavigate } from "react-router-dom";

function UsersTable({ tableData, getAllClientsData }) {
    
    const {
        setConcretUser,
        setOpenDeleteUser,
        setNavbarData,
        setOpenUserUpdate,
        setOpenErrorUpdate
    } = useGlobalContext()

    const navigate = useNavigate();
    const dateUpdate = (date) => {
        return new Date(date).toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "numeric"
        })
    }
    
    const editThisUser = async (item) => {
        await setConcretUser(item);
        setNavbarData(navbarData => navbarData.map(item => { return { ...item, active: false } }));
        navigate('/edit-user');
    }
    
    const deleteThisUser = async (item) => {
        await setConcretUser(item);
        setOpenDeleteUser(true);
    }
    
    const fetchUpdateUser = async (item) => {
        let formData = new FormData();
        formData.append("id", item.id);
        formData.append("facebookProfileId", item.facebookProfileId);
        formData.append("category", item.category);
        formData.append("subscription", item.subscription);
        try {
            const updateData = await updateUser(formData);
            if ( updateData.data ) {
                await getAllClientsData();
                setOpenUserUpdate(true);
            }
        }
        catch (error) {
            setOpenErrorUpdate(true);
        }
    }

    return (
        <div className = "usersTable">
            <div className = "usersTableHeaderBox">
                <h3 className = "usersTableHeaderText">
                    ALL USERS
                </h3>
            </div>
            <div 
                className = "allUsersTableBox" 
                style = {{
                    position: "relative"
                }}
            >
                <div className = "allUsersTableRowBox" >
                    <span className = "userTableSpan tableHeaderSpan">FULL NAME</span>
                    <span className = "userTableSpan tableHeaderSpan">PROFILE TYPE</span>
                    <span className = "userTableSpan tableHeaderSpan">FACEBOOK ID</span>
                    <span className = "userTableSpan tableHeaderSpan">INSTAGRAM ID</span>
                    <span className = "userTableSpan tableHeaderSpan">CATEGORY</span>
                    <span className = "userTableSpan tableHeaderSpan">DATE CREATED</span>
                    <span className = "userTableSpan tableHeaderSpan">ADDITIONAL NOTES</span>
                    <span className = "userTableSpan userActionsSpan tableHeaderSpan">ACTIONS</span>
                </div>
                <div className = "allUsersTableMainBox">
                {
                    tableData && tableData.map(item => <div className = "allUsersTableRowBox" key = { item.id } >
                        <span className = "userTableSpan" style = {{ position: "relative" }}>
                            { item.fullName }
                            <span className = "usersTableNameHiddenSpan">{ item.fullName }</span>
                        </span>
                        <span className = "userTableSpan">{ item.subscription.replaceAll("_", " and ").toLowerCase() }</span>
                        <span className = "userTableSpan">{ item.facebookProfileId }</span>
                        <span className = "userTableSpan">{ item.instagramProfileId ? item.instagramProfileId : "-" }</span>
                        <span className = "userTableSpan userCategorysSpan">
                            <span>{ item.category.replaceAll("_", " ").toLowerCase() }</span>
                            <span>{ item.additionalCategory?.replaceAll("_", " ").toLowerCase() }</span>
                        </span>
                        <span className = "userTableSpan">{ dateUpdate(item.creationDate) }</span>
                        <span className = "userTableSpan userTableNotesSpan">
                            { item.additionalNotes ? item.additionalNotes : "-" }
                        </span>
                        <span className = "userTableSpan userActionsSpan">
                            <span>
                                <CachedIcon
                                    titleAccess="Update"
                                    className = "userTableIcon"
                                    style = {{
                                        color: "#929292",
                                        cursor: "pointer",
                                        fontSize: "28px",
                                        fontWeight: 700
                                    }}
                                    onClick = { fetchUpdateUser.bind(this, item) }
                                />
                            </span>
                            <BorderColorIcon
                                titleAccess = "Edit"
                                className = "userTableIcon"
                                style = {{
                                    color: "#929292",  
                                    cursor: "pointer",
                                    margin: "0 10px",
                                }}
                                onClick = { editThisUser.bind(this, item) }
                            />
                            <DeleteIcon
                                titleAccess = "Delete"
                                className = "userTableIcon"
                                style = {{
                                    color: "#929292",
                                    cursor: "pointer"
                                }}
                                onClick = { deleteThisUser.bind(this,item) }
                            />
                        </span>
                    </div>)
                }
                </div>
            </div>
        </div>
    )
}

export default UsersTable

